import React from "react";
import {Dialog} from "primereact/dialog";

const ConfirmationMessageView = (props) => {
    return (
        <React.Fragment>
            {props.buttonOpen}

            <Dialog visible={props.displayDialog} header={props.dialogHeader} modal={true}
                    onHide={props.onHideDialog} closable={false}
                    style={{width: "45%", textAlign: 'left',}}>

                <div className="p-grid p-fluid">
                    <div className="p-col-12" style={{padding: '.5em'}}>
                        <label htmlFor="fileName" className={"secondary-text"}>{props.dialogLegend.split("|").map(
                            (message) => {
                                return (<React.Fragment>{message} <br/></React.Fragment>);
                            })}</label>
                    </div>
                </div>
            </Dialog>
        </React.Fragment>
    )
};

export default ConfirmationMessageView;